/*
  aycan-hover-disclosures — desktop hover for PLP horizontal facets + header nav.
  Document-level delegation survives Dawn facet AJAX re-renders.
  Close is delayed (200ms) to forgive gaps between summary and dropdown panel.
  Touch / no-hover devices keep native tap-to-open on <details>.
*/
(function () {
  var CLOSE_DELAY = 200;
  var closeTimer;
  var canHover = window.matchMedia('(any-hover: hover)').matches;
  var desktopNav = window.matchMedia('(min-width: 990px)');

  function facetGroup(el) {
    return el && el.closest ? el.closest('.facets__wrapper') || el.closest('.facets-container') : null;
  }

  function headerGroup(el) {
    return el && el.closest ? el.closest('.header__inline-menu') : null;
  }

  function facetDisclosure(el) {
    return el && el.closest ? el.closest('details.facets__disclosure') : null;
  }

  function headerDisclosure(el) {
    if (!desktopNav.matches) return null;
    var menu = el && el.closest ? el.closest('header-menu') : null;
    return menu ? menu.querySelector('details') : null;
  }

  function setAria(details, open) {
    var summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeFacetGroup(group, except) {
    if (!group) return;
    group.querySelectorAll('details.facets__disclosure[open]').forEach(function (d) {
      if (d !== except) {
        d.removeAttribute('open');
        setAria(d, false);
      }
    });
  }

  function closeHeaderGroup(group, except) {
    if (!group) return;
    group.querySelectorAll('header-menu > details[open]').forEach(function (d) {
      if (d !== except) {
        d.removeAttribute('open');
        setAria(d, false);
      }
    });
  }

  function openFacet(details) {
    var group = facetGroup(details);
    if (!group) return;
    clearTimeout(closeTimer);
    closeFacetGroup(group, details);
    if (!details.hasAttribute('open')) details.setAttribute('open', '');
    setAria(details, true);
  }

  function openHeader(details) {
    var group = headerGroup(details);
    if (!group) return;
    clearTimeout(closeTimer);
    closeHeaderGroup(group, details);
    if (!details.hasAttribute('open')) details.setAttribute('open', '');
    setAria(details, true);
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      document.querySelectorAll('details.facets__disclosure[open]').forEach(function (d) {
        d.removeAttribute('open');
        setAria(d, false);
      });
      if (desktopNav.matches) {
        document.querySelectorAll('.header__inline-menu header-menu > details[open]').forEach(function (d) {
          d.removeAttribute('open');
          setAria(d, false);
        });
      }
    }, CLOSE_DELAY);
  }

  function isInsideOpenHoverZone(target) {
    if (!target || !target.closest) return false;
    if (target.closest('details.facets__disclosure[open]')) return true;
    if (desktopNav.matches && target.closest('.header__inline-menu header-menu details[open]')) return true;
    return false;
  }

  document.addEventListener('mouseover', function (e) {
    if (!canHover) return;

    var facet = facetDisclosure(e.target);
    if (facet) {
      openFacet(facet);
      return;
    }

    var header = headerDisclosure(e.target);
    if (header) {
      openHeader(header);
      return;
    }

    if (isInsideOpenHoverZone(e.relatedTarget)) return;

    var hasOpenFacet = document.querySelector('details.facets__disclosure[open]');
    var hasOpenHeader = desktopNav.matches && document.querySelector('.header__inline-menu header-menu > details[open]');
    if ((hasOpenFacet || hasOpenHeader) && !isInsideOpenHoverZone(e.target)) {
      scheduleClose();
    }
  });
})();
